/**
 * `addEventListener` helper.
 * The returned function should be called to `removeEventListener`
 */
export function addEventListener(element, target, listener, options) {
    element.addEventListener(target, listener, options);
    var remove = function () {
        element.removeEventListener(target, listener, options);
    };
    return remove;
}
//# sourceMappingURL=addEventListener.js.map